module.exports = __webpack_public_path__ + "static/media/ankur.49f6db4a.jpeg";